import React from 'react';
import MicroLabel from '../components/MicroLabel';
import { euro } from '../format';

/**
 * Chapter 07 — Money that arrived while you slept.
 *
 * Dividend total and per-year bars on the left, three stats on the right. The
 * per-year bars replace the design's striped placeholder: flat ink fills,
 * measured against the biggest year.
 */
function Dividends({ story }) {
  const dividends = story?.dividends || {};
  const perYear = dividends.perYear || [];
  const maxYear = perYear.length > 0 ? Math.max(...perYear.map((y) => y.value)) : 0;

  return (
    <>
      <h2 className="story-h2">Money that arrived while you slept.</h2>

      <div className="story-dividends">
        <div className="story-dividends-main">
          <MicroLabel>Dividends collected — all time</MicroLabel>
          <div className="story-figure story-dividends-total">{euro(dividends.total)}</div>

          {perYear.length > 0 && (
            <div className="story-year-bars">
              {perYear.map((year) => (
                <div className="story-year-bar" key={year.year}>
                  <div
                    className="story-year-bar-fill"
                    style={{ height: `${maxYear > 0 ? (year.value / maxYear) * 100 : 0}%` }}
                    aria-hidden="true"
                  />
                  <div className="story-year-bar-label">{year.year}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="story-dividends-stats">
          <div className="story-dividends-stat">
            <MicroLabel>Payouts received</MicroLabel>
            <div className="story-dividends-stat-value">{dividends.count ?? 0}</div>
          </div>
          <div className="story-dividends-stat">
            <MicroLabel>Most generous holding</MicroLabel>
            <div className="story-dividends-stat-value">{dividends.topPayer || '————'}</div>
          </div>
          <div className="story-dividends-stat">
            <MicroLabel>Realized gains banked</MicroLabel>
            <div className="story-dividends-stat-value">{euro(story?.realizedGains)}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dividends;
